var Backbone = require('backbone');
Backbone.$ = require('./../sw-jquery/sw-jquery');

module.exports = Backbone;
